export const PLANS_CONTAINER_HEADER_HEIGHT = 52;
export const PLANS_CONTAINER_FOOTER_HEIGHT = 52;

export const momentDayFormat = 'YYYY-MM-DD';

export const CURRENT_PLAN_STATUS_ACTIVE = 'CURRENT_PLAN_STATUS_ACTIVE';
export const CURRENT_PLAN_STATUS_CAN_CREATE = 'CURRENT_PLAN_STATUS_CAN_CREATE';
export const SIMPLE_BIRTH_DATE_FORM_NAME = 'SIMPLE_BIRTH_DATE_FORM_NAME';
